import { coalesceLocaleField } from '../helpers/coalesceLocaleField'
import { groq } from 'next-sanity'
import { LocaleId } from '@portfolio/configs'
import { createBaseImageProjection } from '../projections/createBaseImageProjection'
import { createLinkProjection } from '../projections/createLinkProjection'

export const createSectionServicesProjection = (localeId: LocaleId) => {
  return groq`{
        _key,
        _type,

        ${coalesceLocaleField('text', localeId)},
        technologiesRows[] {
          items[]${createBaseImageProjection(localeId)},
        },

        services[] {
            _key,
            ${coalesceLocaleField('title', localeId)},
            cta${createLinkProjection(localeId)},
            ${coalesceLocaleField('ctaLabel', localeId)},
            ${coalesceLocaleField('description', localeId)},
            "pills": services[]->{
              _key,
              ${coalesceLocaleField('title', localeId)},
            }
        }
      }
  `
}
